import { getSelectedClients } from '../../data/interactions'
import { requestAPI, requestAPIWithFormData } from '../../data/api'

// Certificates are read across every partner, so the read endpoints below are
// called without a clientId. Writes still belong to a single partner: they use
// the partner of the certificate being edited, falling back to the selected one
// when a certificate is being created.
const getSelectedClientId = () => {
	const selectedClients = getSelectedClients()
	if (selectedClients.length === 0) {
		throw new Error('No client id found')
	}
	return selectedClients[0].client_id
}

export const uploadRegistrationCertificate = async ({
	registrationCertificateNumber,
	file,
	effectiveDate,
}) => {
	const urlParams = new URLSearchParams({
		clientId: getSelectedClientId(),
	}).toString()

	const formData = new FormData()
	formData.append(
		'registrationCertificateNumber',
		registrationCertificateNumber,
	)
	if (file) {
		formData.append('file', file)
	}
	if (effectiveDate) {
		formData.append('effectiveDate', effectiveDate)
	}

	return requestAPIWithFormData(
		`/registration-certificates?${urlParams}`,
		'post',
		formData,
	)
}

export const fetchRegistrationCertificate = async ({
	page,
	perPage,
	filters,
}) => {
	const queryParams = {
		limit: perPage,
		offset: Math.abs(page * perPage),
	}

	if (filters) {
		// Stringify the filters object to pass it as a single query parameter
		queryParams.filters = JSON.stringify(filters)
	}

	const urlParams = new URLSearchParams(queryParams).toString()

	return requestAPI(`/registration-certificates?${urlParams}`, 'get')
}

export const fetchRegisteredImages = async ({
	registrationCertificateId,
	page,
	perPage,
	filters,
}) => {
	const queryParams = {
		limit: perPage,
		offset: Math.abs(page * perPage),
	}

	if (filters) {
		queryParams.filters = JSON.stringify(filters)
	}

	const urlParams = new URLSearchParams(queryParams).toString()

	return requestAPI(
		`/registration-certificates/${registrationCertificateId}/images?${urlParams}`,
		'get',
	)
}

export const uploadRegisteredImages = async ({
	partnerImageIds,
	registrationCertificateId,
	clientId,
}) => {
	const urlParams = new URLSearchParams({
		clientId: clientId || getSelectedClientId(),
	}).toString()

	return requestAPI(
		`/registration-certificates/${registrationCertificateId}/images?${urlParams}`,
		'post',
		{
			partnerImageIds,
		},
	)
}

export const deleteManuallyUploadedImage = async ({
	registeredImageId,
	registrationCertificateId,
	clientId,
}) => {
	const urlParams = new URLSearchParams({
		clientId: clientId || getSelectedClientId(),
	}).toString()

	return requestAPI(
		`/registration-certificates/${registrationCertificateId}/images/${registeredImageId}?${urlParams}`,
		'delete',
	)
}

export const getRegistrationCertificateFileLink = async ({
	registrationCertificateId,
}) => {
	return requestAPI(
		`/registration-certificates/${registrationCertificateId}/file`,
		'get',
	)
}

export const deleteRegistrationCertificate = async ({
	registrationCertificateId,
	clientId,
}) => {
	const urlParams = new URLSearchParams({
		clientId: clientId || getSelectedClientId(),
	}).toString()

	return requestAPI(
		`/registration-certificates/${registrationCertificateId}?${urlParams}`,
		'delete',
	)
}

export const bulkValidateRegistrationCertificates = async (certificates) => {
	const urlParams = new URLSearchParams({
		clientId: getSelectedClientId(),
	}).toString()

	return requestAPI(
		`/registration-certificates/bulk/validate?${urlParams}`,
		'post',
		certificates,
	)
}

export const bulkCommitRegistrationCertificates = async (certificates) => {
	const urlParams = new URLSearchParams({
		clientId: getSelectedClientId(),
	}).toString()

	return requestAPI(
		`/registration-certificates/bulk/commit?${urlParams}`,
		'post',
		certificates,
	)
}
